import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { map } from 'rxjs';
import { filterPath } from '../../lib/get-full-path';
import { PICFLOW_STORYBLOK } from '../../picflow-storyblok';

export const isRedirectGuard: CanMatchFn = (route, state) => {
  const storyblokService = inject(PICFLOW_STORYBLOK);

  const path = filterPath(state.map(segment => segment.path)).join('/') || 'home';

  return storyblokService.getStory(path).pipe(
    map(resp => {
      if (!resp || !resp.story) return false;
      return resp.story.content.component === 'Redirect';
    })
  );
};
